import { render, staticRenderFns } from "./EfetuarPagamento.vue?vue&type=template&id=8ffb8d2a&scoped=true&"
import script from "./EfetuarPagamento.vue?vue&type=script&lang=js&"
export * from "./EfetuarPagamento.vue?vue&type=script&lang=js&"
import style0 from "./EfetuarPagamento.vue?vue&type=style&index=0&id=8ffb8d2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ffb8d2a",
  null
  
)

export default component.exports